import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedOrder, ExtendedOrderListResponse, OrderQueryParams } from '@frontend/order/types';

export class OrderExtendedClient extends APIClient {
    public static readonly endpoint = '/order-api/ext/v1';

    /**
     * GET /ext/v1/orders – returns paginated ExtendedOrder list with resolved order relations.
     */
    public static async fetchOrdersExtended(queryParams?: ApiQueryParams<OrderQueryParams>): Promise<ExtendedOrderListResponse> {
        return await this.apiPaginated<ExtendedOrderListResponse, OrderQueryParams>(`${this.endpoint}/orders`, queryParams);
    }

    /**
     * GET /ext/v1/orders/:id – returns a single ExtendedOrder with resolved order relations.
     */
    public static async fetchOrderExtended(accountId: string, orderId: string): Promise<ExtendedOrder> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/orders/${orderId}`);
        return await this.handleResponse<ExtendedOrder>(response);
    }
}
